import React from 'react';
import { Section } from './Shared';
import { Bat, Pumpkin, Star } from './HalloweenDecor';
export function EmotionalClose() {
  return <Section id="cierre" tone="violet" innerClassName="max-w-3xl text-center" decor={<>
          <Star className="absolute left-[10%] top-16 w-4 text-brand-orange" data-id="element-42" data-mp="vl1sfgaqkmq0" />
          <Star className="absolute right-[14%] top-28 w-3 text-brand-orange/70" data-id="element-43" data-mp="qo1nj8pmhq0h" />
          <Bat className="absolute right-[6%] top-10 w-14 text-white/10 md:w-20" data-id="element-44" data-mp="mm7pz9aq524j" />
          <Pumpkin className="absolute bottom-10 left-[6%] w-12 text-brand-orange/40 md:w-16" data-id="element-45" data-mp="hmleb4ajntxu" />
        </>} data-id="element-41" data-mp="10dl8ql0t5vyi">
      <h2 className="text-balance text-[30px] font-extrabold leading-[1.15] text-brand-cream md:text-5xl" data-id="element-46" data-mp="cn8rgjjoamv9">
        <span className="block" data-id="element-47" data-mp="7oxh87pguaci">El disfraz dura una noche.</span>
        <span className="mt-1 block text-brand-orange" data-id="element-48" data-mp="7qiei53607e2">
          El recuerdo de crearlo juntos puede acompañarlos mucho más.
        </span>
      </h2>
      <div className="mx-auto mt-6 h-1 w-16 rounded-full bg-brand-orange" aria-hidden="true" data-id="element-49" data-mp="2226ri1pu5zvt" />
      <p className="mt-6 text-base leading-relaxed text-brand-cream/90 md:text-xl md:leading-relaxed" data-id="element-50" data-mp="3529d5rqvj101">
        Una mesa con materiales. Una idea que empieza a tomar forma. Los chicos eligiendo colores y agregando sus
        detalles. Este Halloween, sumá un momento para compartir antes de salir a festejar.
      </p>
      <p className="mt-6 font-display text-xl font-bold text-brand-cream md:text-2xl" data-id="element-51" data-mp="3047liifdttcy">
        Elegí una propuesta y empiecen a darle su propia personalidad.
      </p>
    </Section>;
}